// extracted by mini-css-extract-plugin
export default {"container":"style_container__Sb5H+","content":"style_content__POFGG"};